import React from 'react';
import { useSelector } from 'react-redux';
import PresenceBadge from '../PresenceBadge';
import { GeckoAvatar, GeckoField, GECKO_CONSTS } from '../../ui';
import './index.scss';
import { sortVisibleAgents, sortTeams } from 'selectors';
import getPresence from 'utilities/getPresence';

export const AgentOption = (props) => {
  return (
    <div className="AgentTeamSelect-AgentOption" role="option">
      <PresenceBadge
        presence={getPresence(
          props.presence,
          props.web_available || props.mobile_available
        )}
      >
        <GeckoAvatar
          size={'sm'}
          name={props.full_name}
          color={props.additional.avatar_color}
          bgImage={props.additional.profile_picture_url}
        />
      </PresenceBadge>
      <span className="avatar-name">&nbsp;{props.full_name}</span>
    </div>
  );
};

export const TeamOption = (props) => {
  return (
    <div className="AgentTeamSelect-TeamOption" role="option">
      <PresenceBadge presence={props.presence}>
        <GeckoAvatar size={'sm'} name={props.name} />
      </PresenceBadge>
      <span className="avatar-name">&nbsp;{props.name}</span>
    </div>
  );
};

export const AgentTeamSelect = (props) => {
  const agents = useSelector(sortVisibleAgents);
  const teams = useSelector(sortTeams);

  const renderOption = (option) => {
    if (option.agent) {
      return <AgentOption {...option.agent} />;
    }
    if (option.team) {
      return <TeamOption {...option.team} />;
    }
    return option.label; // If it's a group heading just return it
  };

  const handleChange = (_key, value) => {
    props.onChange(value);
  };

  const field = {
    key: 'value',
    type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
    options: [
      ...(props.allowUnassignedOption
        ? [
            {
              unassigned: {},
              label: 'Unassigned',
              value: `agent_0`,
            },
          ]
        : []),
      {
        label: props.agentSeperatorLabel || 'Agents',
        options: agents.map((agent) => {
          return {
            agent: agent,
            label: agent.full_name,
            value: `agent_${agent.id}`,
          };
        }),
      },
      {
        label: props.teamSeperatorLabel || 'Teams',
        options: teams,
      },
    ],
    optionRenderer: renderOption,
    config: props.selectProps || {},
    placeholder: props.placeholder,
  };

  const values = { value: props.value };
  const specialClass = `AgentTeamSelect ${props.specialClass}`;
  return (
    <div className={specialClass}>
      <GeckoField field={field} values={values} handler={handleChange} />
    </div>
  );
};
export default AgentTeamSelect;
